// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"b4-z"};